export const ru = {
  seo: {
    siteTitle: 'Дракульные Тулзы',
    siteKeywords:
      'веб-инструменты, инструменты разработчика, react, vite, json форматтер, генератор паролей, конвертер цветов, pomodoro, dracula theme',
  },
  common: {
    searchLabel: 'Поиск инструментов',
    searchPlaceholder: 'Поиск инструментов...',
    language: 'Язык',
    openMenu: 'Открыть меню',
    closeMenu: 'Закрыть меню',
    loading: 'Загрузка инструмента...',
    copied: 'Скопировано!',
    clear: 'Очистить',
    copy: 'Копировать',
    generate: 'Генерировать',
    encode: 'Кодировать',
    decode: 'Декодировать',
    format: 'Форматировать',
    minify: 'Минифицировать',
    validate: 'Проверить',
    result: 'Результат',
    noSearchResults: 'Инструменты по запросу не найдены.',
    focus: 'Фокус',
    shortBreak: 'Короткий перерыв',
    longBreak: 'Длинный перерыв',
    start: 'Старт',
    pause: 'Пауза',
    resume: 'Продолжить',
    reset: 'Сброс',
    skip: 'Пропустить',
    elapsed: 'Прошло',
    today: 'Сегодня',
    week: 'За неделю',
    total: 'Всего',
    streak: 'Текущая серия',
  },
  navigation: {
    categories: {
      core: 'Основные инструменты',
      formatters: 'Форматтеры и валидаторы',
      misc: 'Другое',
    },
    tools: {
      passwordGenerator: {
        name: 'Генератор паролей',
        description:
          'Создавайте надежные пароли с настройкой длины, количества и набора символов.',
      },
      characterCounter: {
        name: 'Счетчик символов',
        description:
          'Подсчитывайте символы, слова, строки и самые частые слова в тексте.',
      },
      htmlSpaces: {
        name: 'HTML пробелы',
        description:
          'Подбирайте специальные HTML-сущности для пробелов и типографики.',
      },
      encodingConverter: {
        name: 'Конвертер кодировок',
        description:
          'Исправляйте кракозябры и возвращайте текст из старых кодировок в UTF-8.',
      },
      base64: {
        name: 'Base64 кодирование',
        description: 'Кодируйте и декодируйте UTF-8 текст в Base64.',
      },
      jsonFormatter: {
        name: 'JSON форматтер',
        description:
          'Форматируйте, проверяйте и минифицируйте JSON с подсветкой синтаксиса.',
      },
      colorConverter: {
        name: 'Конвертер цветов',
        description:
          'Переводите цвета между HEX, RGB, HSL и ARGB и собирайте палитры.',
      },
      urlTool: {
        name: 'URL кодирование',
        description:
          'Кодируйте и декодируйте значения для безопасной передачи в URL.',
      },
      htmlEntities: {
        name: 'HTML сущности',
        description: 'Безопасно кодируйте и декодируйте HTML-сущности.',
      },
      iphoneCountdown: {
        name: 'Таймер iPhone',
        description:
          'Следите за следующим ожидаемым анонсом iPhone и изучайте историю релизов.',
      },
      pomodoro: {
        name: 'Pomodoro таймер',
        description:
          'Запускайте фокус-сессии с сохранением настроек, статистики, звуков и уведомлений.',
      },
    },
  },
  tools: {
    passwordGenerator: {
      outputLabel: 'Сгенерированный пароль',
      uppercase: 'Прописные буквы (A-Z)',
      lowercase: 'Строчные буквы (a-z)',
      numbers: 'Цифры (0-9)',
      symbols: 'Специальные символы (!@#$%)',
      avoidAmbiguous: 'Избегать похожих символов (1, l, I, 0, O)',
      passwordLength: 'Длина пароля',
      passwordCount: 'Количество паролей',
      copyAll: 'Копировать все',
      showPassword: 'Показать пароль',
      hidePassword: 'Скрыть пароль',
      tipsTitle: 'Советы по безопасности паролей',
      tips: [
        'Используйте пароль длиной не менее 12 символов.',
        'Комбинируйте прописные и строчные буквы, цифры и специальные символы.',
        'Не используйте одинаковые пароли для разных сервисов.',
        'Регулярно обновляйте критичные учетные данные.',
        'Храните пароли в надежном менеджере паролей.',
      ],
    },
    characterCounter: {
      placeholder: 'Наберите или вставьте ваш текст в это поле...',
      characters: 'Символов',
      words: 'Слов',
      lines: 'Строк',
      withoutSpaces: 'Без пробелов',
      frequencyTitle: 'Частотный анализ',
      frequencyLead: 'Топ-5 наиболее часто используемых слов:',
      notEnoughData: 'Недостаточно данных для анализа.',
    },
    htmlSpaces: {
      selectLabel: 'Выберите сущность',
      previewTitle: 'Предпросмотр',
      previewPrefix: 'Текст',
      previewSuffix: 'с пробелом',
      tableTitle: 'Справочная таблица HTML-пробелов',
      columns: {
        name: 'Название',
        entity: 'Сущность',
        description: 'Описание',
        width: 'Ширина',
      },
      options: {
        nbsp: 'Неразрывный пробел',
        ensp: 'En space',
        emsp: 'Em space',
        thinsp: 'Тонкий пробел',
        zwsp: 'Пробел нулевой ширины',
        ndash: 'Среднее тире',
        mdash: 'Длинное тире',
      },
      rows: [
        {
          id: 'nbsp',
          entity: '&nbsp;',
          description: 'Предотвращает перенос строки между словами.',
          width: 'Как обычный пробел',
        },
        {
          id: 'ensp',
          entity: '&ensp;',
          description: 'Пробел шириной в букву N.',
          width: '0.5em',
        },
        {
          id: 'emsp',
          entity: '&emsp;',
          description: 'Пробел шириной в букву M.',
          width: '1em',
        },
        {
          id: 'thinsp',
          entity: '&thinsp;',
          description: 'Узкий пробел для аккуратной типографики.',
          width: '0.2em',
        },
        {
          id: 'zwsp',
          entity: '&zwsp;',
          description: 'Невидимая точка возможного переноса.',
          width: '0',
        },
      ],
    },
    encodingConverter: {
      encodingLabel: 'Кодировка',
      inputLabel: 'Входной текст',
      inputPlaceholder: 'Вставьте текст с неправильной кодировкой здесь...',
      outputLabel: 'Результат конвертации',
      outputPlaceholder: 'Результат конвертации появится здесь...',
      copyResult: 'Копировать результат',
      errorPrefix: 'Ошибка кодировки',
    },
    base64: {
      tabs: {
        encode: 'Кодирование',
        decode: 'Декодирование',
      },
      encodeInputLabel: 'Исходный текст',
      encodeInputPlaceholder: 'Введите текст для кодирования в Base64...',
      encodeOutputLabel: 'Результат кодирования',
      encodeOutputPlaceholder: 'Результат кодирования Base64 появится здесь...',
      decodeInputLabel: 'Base64 строка',
      decodeInputPlaceholder: 'Введите Base64 строку для декодирования...',
      decodeOutputLabel: 'Результат декодирования',
      decodeOutputPlaceholder:
        'Результат декодирования Base64 появится здесь...',
      encodeError: 'Ошибка кодирования: {{message}}',
      decodeError: 'Ошибка декодирования: {{message}}',
    },
    jsonFormatter: {
      inputLabel: 'Введите JSON',
      inputPlaceholder: 'Введите или вставьте JSON сюда...',
      outputLabel: 'Результат',
      copyResult: 'Копировать результат',
      valid: 'JSON валиден.',
      formatError: 'Ошибка форматирования: {{message}}',
      minifyError: 'Ошибка минификации: {{message}}',
      validateError: 'Ошибка валидации: {{message}}',
    },
    colorConverter: {
      pickerTitle: 'Подбор цвета',
      paletteTitle: 'Цветовая палитра',
      paletteLead: 'Связанные цвета на основе выбранного.',
      hex: 'HEX',
      rgb: 'RGB',
      hsl: 'HSL',
      rgbDecimal: 'RGB Decimal (0-1)',
      argb: 'ARGB (0-255)',
      argbDecimal: 'ARGB Decimal (0-1)',
      copyHex: 'Копировать HEX',
      copyRgb: 'Копировать RGB',
      copyHsl: 'Копировать HSL',
      copyArgb: 'Копировать ARGB',
      baseColor: 'Основной: {{color}}',
      complementary: 'Комплементарный: {{color}}',
      copiedSwatch: 'Скопировано!',
      hints: {
        hex: 'HEX формат: #RRGGBB или RRGGBB (например #6272A4).',
        rgb: 'RGB формат: rgb(R, G, B), значения от 0 до 255.',
        hsl: 'HSL формат: hsl(H, S%, L%), где оттенок от 0 до 360.',
        rgbDecimal: 'RGB decimal формат: rgb(R, G, B), значения от 0 до 1.',
        argb: 'ARGB формат: argb(A, R, G, B), значения от 0 до 255.',
        argbDecimal:
          'ARGB decimal формат: argb(A, R, G, B), значения от 0 до 1.',
      },
    },
    urlTool: {
      tabs: {
        encode: 'Кодирование',
        decode: 'Декодирование',
      },
      encodeInputLabel: 'Исходный текст',
      encodeInputPlaceholder: 'Введите текст для URL-кодирования...',
      encodeOutputLabel: 'Результат кодирования',
      encodeOutputPlaceholder: 'Результат URL-кодирования появится здесь...',
      decodeInputLabel: 'URL-кодированная строка',
      decodeInputPlaceholder:
        'Введите URL-кодированную строку для декодирования...',
      decodeOutputLabel: 'Результат декодирования',
      decodeOutputPlaceholder: 'Результат URL-декодирования появится здесь...',
      decodeError:
        'Ошибка декодирования: некорректная escape-последовательность URL.',
    },
    htmlEntities: {
      tabs: {
        encode: 'Кодирование',
        decode: 'Декодирование',
      },
      encodeInputLabel: 'Исходный текст',
      encodeInputPlaceholder: 'Введите текст для кодирования HTML-сущностей...',
      encodeOutputLabel: 'Результат кодирования',
      encodeOutputPlaceholder:
        'Результат кодирования HTML-сущностей появится здесь...',
      decodeInputLabel: 'HTML-сущности',
      decodeInputPlaceholder: 'Введите HTML-сущности для декодирования...',
      decodeOutputLabel: 'Результат декодирования',
      decodeOutputPlaceholder:
        'Результат декодирования HTML-сущностей появится здесь...',
    },
    iphoneCountdown: {
      eventLead: 'Следующая презентация Apple ожидается',
      eventTail: 'в кампусе Apple Park, Калифорния.',
      historyTitle: 'История выпусков iPhone',
      columns: {
        model: 'Модель',
        date: 'Дата выпуска',
        features: 'Основные особенности',
      },
      units: {
        days: 'дней',
        hours: 'часов',
        minutes: 'минут',
        seconds: 'секунд',
      },
      history: [
        {
          model: 'iPhone 18 Pro / Pro Max',
          date: '18 сентября 2026',
          features:
            'Чип A20 Pro (2 нм) с 12 ГБ памяти, главная камера 48 Мп с переменной диафрагмой, улучшенная система охлаждения. Автономность до 36 часов видео (Pro Max — до 45). Siri с Visual Intelligence прямо в приложении камеры, LiDAR, USB-C, до 2 ТБ памяти.',
        },
        {
          model: 'iPhone Duo',
          date: '23 октября 2026',
          features:
            'Первый складной iPhone: внутренний дисплей 7,6″ и внешний 5,4″, чип A20 Pro, Touch ID в боковой кнопке. Продажи с 23 октября 2026, от $1999.',
        },
        {
          model: 'iPhone 17',
          date: '19 сентября 2025',
          features:
            'Чип A19, дисплей 6,3″ с частотой 120 Гц, двойная камера 48 Мп, новый сетевой чип Apple N1, USB-C с MagSafe и Qi2, пять цветов.',
        },
        {
          model: 'iPhone 17 Pro / Pro Max',
          date: '19 сентября 2025',
          features:
            'Чип A19 Pro и 12 ГБ памяти, три камеры по 48 Мп с LiDAR и самым длинным телефото в линейке, испарительная камера охлаждения, до 2 ТБ памяти.',
        },
        {
          model: 'iPhone Air',
          date: '19 сентября 2025',
          features:
            'Самый тонкий iPhone в истории — 5,6 мм, титановый корпус. Дисплей 6,5″ на 120 Гц, чип A19 Pro, камеры 48 Мп и 18 Мп, только eSIM.',
        },
        {
          model: 'iPhone 16e',
          date: '28 февраля 2025',
          features:
            'Доступный iPhone: чип A18, камера 48 Мп с 2× кроп-зумом, USB-C, поддержка Apple Intelligence, дисплей 6,1″, от $599.',
        },
        {
          model: 'iPhone 16',
          date: '20 сентября 2024',
          features:
            'Чип A18 и Apple Intelligence, кнопка Camera Control, Action Button, камера Fusion 48 Мп с 2× телефото и макро, заметный рост автономности, пять ярких цветов.',
        },
        {
          model: 'iPhone 15',
          date: '22 сентября 2023',
          features:
            'Dynamic Island на базовых моделях, камера 48 Мп с 2× телефото, порт USB-C, чип A16, дорожная помощь через спутник.',
        },
        {
          model: 'iPhone 14',
          date: '16 сентября 2022',
          features:
            'Чип A15, обнаружение аварий и экстренный SOS через спутник, улучшенная камера для съёмки при слабом свете, модель Plus с дисплеем 6,7″.',
        },
        {
          model: 'iPhone 13',
          date: '24 сентября 2021',
          features:
            'Чип A15, двойная камера с режимом «Киноэффект», стекло Ceramic Shield, до 2,5 часов больше автономности, яркий дисплей 800 нит.',
        },
      ],
    },
    pomodoro: {
      workDuration: 'Рабочая сессия (мин)',
      shortBreakDuration: 'Короткий перерыв (мин)',
      longBreakDuration: 'Длинный перерыв (мин)',
      sessionsCount: 'Сессий до длинного перерыва',
      autoStartBreaks: 'Автоматически начинать перерывы',
      autoStartPomodoros: 'Автоматически начинать рабочие сессии',
      enableNotifications: 'Включить уведомления',
      enableSounds: 'Включить звуки',
      settingsTitle: 'Настройки',
      statsTitle: 'Статистика',
      aboutTitle: 'О технике Pomodoro',
      resetSettings: 'Сбросить настройки',
      resetStats: 'Сбросить статистику',
      workCompleteTitle: 'Фокус-сессия завершена!',
      workCompleteBody: 'Пора сделать перерыв.',
      shortBreakCompleteTitle: 'Перерыв окончен!',
      shortBreakCompleteBody: 'Пора вернуться к работе.',
      longBreakCompleteTitle: 'Длинный перерыв окончен!',
      longBreakCompleteBody: 'Пора вернуться к работе.',
      resetSettingsConfirm:
        'Сбросить настройки Pomodoro к значениям по умолчанию?',
      resetStatsConfirm: 'Сбросить всю статистику Pomodoro?',
      aboutIntro:
        'Техника Pomodoro — это метод управления временем, основанный на чередовании сфокусированных интервалов работы и запланированных перерывов.',
      aboutSteps: [
        'Выберите одну задачу для выполнения.',
        'Установите Pomodoro-таймер, обычно на 25 минут.',
        'Работайте, пока таймер не завершится.',
        'Сделайте короткий перерыв, обычно 5 минут.',
        'После четырех сессий сделайте длинный перерыв.',
      ],
      aboutOutro:
        'Регулярные паузы помогают сохранять концентрацию, снижать усталость и поддерживать темп на длинной дистанции.',
    },
  },
  cookies: {
    ariaLabel: 'Уведомление об использовании cookie',
    text: 'Мы используем файлы cookie и локальное хранилище: они нужны, чтобы запоминать настройки, и — с вашего согласия — для анонимной статистики посещений (Яндекс.Метрика). Подробнее — в разделе',
    accept: 'Принять',
    decline: 'Отклонить',
  },
  pages: {
    contactNote: 'Есть вопрос, идея или предложение? Напишите нам через',
    contactLinkLabel: 'контактную форму на devdom.ru',
    about: {
      metaTitle: 'О проекте | Дракульные Тулзы',
      metaDescription:
        'О проекте «Дракульные Тулзы» — коллекция бесплатных онлайн-инструментов для веб-разработчиков от студии DEVDOM.',
      heading: 'О проекте',
      intro:
        '«Дракульные Тулзы» (Dracula Tools) — небольшая коллекция бесплатных инструментов для веб-разработчиков и всех, кто работает с текстом, кодом и данными. Мы собрали на одном сайте утилиты, которыми пользуемся сами: генератор паролей, счётчик символов, конвертер кодировок, Base64, JSON-форматтер, конвертер цветов и другие.',
      sections: [
        {
          title: 'Тема Dracula',
          paragraphs: [
            'Сайт оформлен в тёмной теме Dracula — одной из самых популярных цветовых схем для редакторов кода и терминалов. Отсюда и название: Dracula Tools / «Дракульные Тулзы».',
          ],
        },
        {
          title: 'Всё работает прямо в браузере',
          paragraphs: [
            'Инструменты не отправляют ваши данные на сервер: пароли, текст, JSON и другие значения обрабатываются локально и не покидают ваш браузер. Сгенерированные пароли нигде не сохраняются — их можно в любой момент сгенерировать заново.',
          ],
        },
        {
          title: 'Кто делает проект',
          paragraphs: [
            'Проект развивает студия DEVDOM: мы делаем сайты, интернет-магазины, интеграции и ИИ-автоматизацию для малого и среднего бизнеса. Список инструментов постепенно пополняется — часть из них появляется из наших собственных рабочих задач.',
          ],
        },
      ],
    },
    privacy: {
      metaTitle: 'Политика конфиденциальности | Дракульные Тулзы',
      metaDescription:
        'Как «Дракульные Тулзы» обращаются с данными: все инструменты работают локально, аналитика подключается только с вашего согласия.',
      heading: 'Политика конфиденциальности',
      updated: 'Последнее обновление: 12 октября 2026 г.',
      intro:
        'Эта политика описывает, какие данные обрабатываются при использовании сайта «Дракульные Тулзы» (tools.devdom.ru). Оператор сайта — студия DEVDOM (devdom.ru).',
      sections: [
        {
          title: 'Данные инструментов',
          paragraphs: [
            'Все инструменты работают полностью в вашем браузере. Текст, пароли, JSON и другие данные, которые вы вводите, не передаются на наши серверы и не сохраняются. Регистрация на сайте не требуется, персональные данные мы не собираем.',
          ],
        },
        {
          title: 'Локальное хранилище браузера',
          paragraphs: [
            'Чтобы запоминать настройки — выбранный язык, параметры инструментов, последний открытый инструмент и решение по cookie — сайт использует локальное хранилище (localStorage) вашего браузера. Эти данные хранятся только на вашем устройстве и удаляются вместе с данными сайта в настройках браузера.',
          ],
        },
        {
          title: 'Аналитика и cookie',
          paragraphs: [
            'С вашего согласия сайт подключает Яндекс.Метрику — сервис веб-аналитики, который собирает обезличенную статистику посещений: просмотренные страницы, тип устройства, примерный регион. Метрика использует файлы cookie. Если вы отклоняете согласие, аналитика не загружается; изменить решение можно в любой момент, очистив данные сайта в браузере.',
          ],
        },
        {
          title: 'Сторонние сервисы',
          paragraphs: [
            'Для работы сайт загружает шрифты (Google Fonts) и библиотеку иконок (CDN cdnjs), а после согласия — Яндекс.Метрику. Эти сервисы в рамках обычной работы интернета получают технические данные запроса: IP-адрес и данные браузера.',
          ],
        },
        {
          title: 'Ваши права',
          paragraphs: [
            'Вы можете в любой момент отозвать согласие на аналитику и удалить локальные данные сайта, очистив его данные в настройках браузера. По любым вопросам об обработке данных напишите нам через контактную форму.',
          ],
        },
        {
          title: 'Изменения политики',
          paragraphs: [
            'Политика может обновляться: актуальная версия всегда опубликована на этой странице.',
          ],
        },
      ],
    },
  },
  footer: {
    about: 'О проекте',
    privacy: 'Политика конфиденциальности',
    contact: 'Связаться с нами',
    madeBy: 'Сделано в DEVDOM',
  },
} as const;
